import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Navbar from "./components/Navbar";
import { Toaster } from "react-hot-toast";
import { useAppContext } from "./context/AppContext";
import AddBlog from "./pages/AddBlog";
import ListBlog from "./pages/ListBlog";
import Comments from "./pages/Comments";
import Latestdashboard from "./pages/Latestdashboard";
import "quill/dist/quill.snow.css";
import Blog from "./pages/Blog";

function App() {
  const { token } = useAppContext();

  return (
    <div>
      <Toaster />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/blog/:id" element={<Blog />} />
        <Route path="/dashboard" element={token ? <Dashboard /> : <Login />}>
          <Route index element={<Latestdashboard />} />
          <Route path="addBlog" element={<AddBlog />} />
          <Route path="listBlog" element={<ListBlog />} />
          <Route path="comments" element={<Comments />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
